import classNameBind from 'classnames/bind';
import React from 'react';
import Icon from '../../Icon';
import styles from './Button.module.css';

const bindClasses = classNameBind.bind(styles);

/**
 * Button replacement for draggable elements build on non active elements.
 * It's used as workaround an issue where some browsers don't react to dragging "button" element.
 * Affected browsers: IE, Edge, Firefox.
 *
 * https://github.com/react-dnd/react-dnd/issues/803
 * https://bugzilla.mozilla.org/show_bug.cgi?id=568313
 */
const Button = ({
  text,
  color,
  active,
  icon,
  onClick,
}) => (
  <div
    className={bindClasses('button', color, { active })}
    role="button"
    tabIndex="0"
    onClick={onClick}
  >
    {
      icon
        ? (
          <Icon name={icon} size="small" />
        ) : ''
    }
    <div className={bindClasses('text')}>{text}</div>
    <Icon name="chevron-down" />
  </div>
);

export default Button;
